import React from 'react'
import { Loader } from '../loader'

const ButtonOutline = ({children, transparent, outlineColor = '#999', className, style, disabled, isLoading, ...props}) => {
  return (
    <button
      className={`${!transparent && 'bg-white'} border rounded text-center p-2 w-full text-sm ${className} ${disabled && ' opacity-50 cursor-not-allowed'}`}
      style={{
        borderColor: outlineColor === 'primary' ? '#52BAE2' : outlineColor,
        ...style
      }}
      disabled={disabled || isLoading}
      {...props}
    >
      {
        isLoading ? (
          <Loader />
        ) : children
      }
    </button>
  )
}

export { ButtonOutline }
